module.exports = __webpack_public_path__ + "static/media/mon-sun_and_everyday_digital.185ff9f5.webp";